import React from "react";
import T from "prop-types";
import { decorators } from "@orange-marmalade/paginate-this";
import { translateProps } from "MODULES/shared/decorators";
import { DataTable } from "MODULES/shared/components";
import Row from "./Row";

export function Table({ results, isLoading }) {
  if (isLoading || results.length > 0) {
    return (
      <DataTable
        loading={isLoading}
        withoutBaseline
        responsive={false}
        striped={false}
      >
        <DataTable.Head>
          <th />
          <th>Message</th>
          <th>Link</th>
          <th>Date</th>
          <th />
        </DataTable.Head>
        <DataTable.Body>{results.map(r => <Row log={r} />)}</DataTable.Body>
      </DataTable>
    );
  }

  return <p>You do not have any logs at this time</p>;
}

Table.propTypes = {
  results: T.arrayOf(T.shape({})).isRequired,
  isLoading: T.bool.isRequired
};

const withListId = translateProps(() => ({ listId: "searchAccountingLogs" }));

export default withListId(decorators.tabulate(Table));



// WEBPACK FOOTER //
// ./app/modules/AccountingLogs/Search/Table.jsx